export const createPlayerEventKey = (playerId: string, eventId: string) => `${eventId}-${playerId}`;
